<div [formGroup]="form">
  <div class="form-spacing">
    <!-- Data richiesta (View only) -->
    <div class="column">
      <label class="label">{{ 'pre-employment.selfservice.declaration-date.label' | translate }}</label>
      <p class="text-dark">{{ form.get('createdAt')?.value | date: 'dd/MM/yyyy' }}</p>
    </div>

    <!-- Accettazione trattamento dati -->
    <div class="row gap-small">
      <p-checkbox inputId="notesAcknowledged" formControlName="notesAcknowledged" binary="true"></p-checkbox>
      <label for="notesAcknowledged" class="row gap-small">
        {{ 'selfservice-request.personal-contacts-change.data-processing-consent.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>
      <p-button
        type="button"
        class="p-ml-4 p-pt-0 p-pb-0"
        outlined="true"
        label="{{ 'selfService.open.file.label' | translate }}"
        (onClick)="openPrivacyPolicy()"
      ></p-button>
    </div>

    <small
      class="text-red-500"
      *ngIf="
        form.get('notesAcknowledged')?.invalid &&
        (form.get('notesAcknowledged')?.dirty || form.get('notesAcknowledged')?.touched)
      "
    >
      {{ 'selfservice-request.personal-contacts-change.validation.consent-required' | translate }}
    </small>

    <!-- Tel. Fisso -->
    <div class="column">
      <label
        for="landlinePhone"
        class="label"
        [innerHTML]="'selfservice-request.personal-contacts-change.landline-phone.label' | translate"
      >
      </label>
      <input
        pInputText
        id="landlinePhone"
        type="text"
        formControlName="landlinePhone"
        placeholder="{{ 'selfservice-request.personal-contacts-change.landline-phone.placeholder' | translate }}"
        class="full-width"
      />
      <small class="text-red-500" *ngIf="form.get('landlinePhone')?.invalid && form.get('landlinePhone')?.touched">
        {{ 'selfservice-request.personal-contacts-change.validation.phone-invalid' | translate }}
      </small>
    </div>

    <!-- Email -->
    <div class="column">
      <label for="email" class="label">
        {{ 'selfservice-request.personal-contacts-change.email.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>
      <input
        pInputText
        id="email"
        type="email"
        formControlName="email"
        placeholder="{{ 'selfservice-request.personal-contacts-change.email.placeholder' | translate }}"
        class="full-width"
      />
      <small class="text-red-500" *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
        {{
          form.get('email')?.errors?.['required']
            ? ('selfservice-request.personal-contacts-change.validation.email-required' | translate)
            : ('selfservice-request.personal-contacts-change.validation.email-invalid' | translate)
        }}
      </small>
    </div>

    <!-- Cellulare -->
    <div class="column">
      <label for="mobilePhone" class="label">
        {{ 'selfservice-request.personal-contacts-change.mobile-phone.label' | translate }}
        <span class="mr-1 text-red-500">*</span>
      </label>
      <input
        pInputText
        id="mobilePhone"
        type="text"
        formControlName="mobilePhone"
        placeholder="{{ 'selfservice-request.personal-contacts-change.mobile-phone.placeholder' | translate }}"
        class="full-width"
      />
      <small class="text-red-500" *ngIf="form.get('mobilePhone')?.invalid && form.get('mobilePhone')?.touched">
        {{ 'selfservice-request.personal-contacts-change.validation.phone-invalid' | translate }}
      </small>
    </div>
  </div>
</div>

<app-repository-show-file-dialog
  [visible]="showDetailFileDialog()"
  [fileType]="detailFileType()"
  (close)="onCloseShowDialog()"
  [fileUrl]="getDataProcessingByCompany()"
  [fileName]="fileName() || ''"
/>
